import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackCommsDashboardTabViewedSpec,
  trackCommsEntryPointClickedSpec,
  trackCommsSetupCompletedSpec,
  trackCommsSetupStartedSpec,
  trackCommsSetupStepAbandonedSpec,
  trackCommsSetupStepCompletedSpec,
  trackInboxFilterAppliedSpec,
  trackInboxItemUpdatedSpec,
  trackInboxItemViewedSpec,
  trackInboxSessionEndedSpec,
  trackInboxSessionStartedSpec,
  trackObjectiveConfiguredSpec,
  trackObjectiveRemovedSpec,
  trackObjectiveSelectedSpec,
  trackObjectiveViewedSpec,
  type CommsDashboardTabViewed,
  type CommsEntryPointClicked,
  type CommsSetupCompleted,
  type CommsSetupStarted,
  type CommsSetupStepAbandoned,
  type CommsSetupStepCompleted,
  type InboxFilterApplied,
  type InboxItemUpdated,
  type InboxItemViewed,
  type InboxSessionEnded,
  type InboxSessionStarted,
  type ObjectiveConfigured,
  type ObjectiveRemoved,
  type ObjectiveSelected,
  type ObjectiveViewed,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const commsEvents: SnowplowEventMap = {
  [TrackingEventName.CommsDashboardTabViewed]: (props) =>
    trackCommsDashboardTabViewedSpec(props as CommsDashboardTabViewed),

  [TrackingEventName.CommsEntryPointClicked]: (props) =>
    trackCommsEntryPointClickedSpec(props as CommsEntryPointClicked),

  [TrackingEventName.CommsSetupStarted]: (props) =>
    trackCommsSetupStartedSpec(props as CommsSetupStarted),

  [TrackingEventName.CommsSetupStepCompleted]: (props) =>
    trackCommsSetupStepCompletedSpec(props as CommsSetupStepCompleted),

  [TrackingEventName.CommsSetupStepAbandoned]: (props) =>
    trackCommsSetupStepAbandonedSpec(props as CommsSetupStepAbandoned),

  [TrackingEventName.CommsSetupCompleted]: (props) =>
    trackCommsSetupCompletedSpec(props as CommsSetupCompleted),

  [TrackingEventName.ObjectiveSelected]: (props) =>
    trackObjectiveSelectedSpec(props as ObjectiveSelected),

  [TrackingEventName.ObjectiveRemoved]: (props) =>
    trackObjectiveRemovedSpec(props as ObjectiveRemoved),

  [TrackingEventName.ObjectiveConfigured]: (props) =>
    trackObjectiveConfiguredSpec(props as ObjectiveConfigured),

  [TrackingEventName.ObjectiveViewed]: (props) =>
    trackObjectiveViewedSpec(props as ObjectiveViewed),

  [TrackingEventName.InboxSessionStarted]: (props) =>
    trackInboxSessionStartedSpec(props as InboxSessionStarted),

  [TrackingEventName.InboxSessionEnded]: (props) =>
    trackInboxSessionEndedSpec(props as InboxSessionEnded),

  [TrackingEventName.InboxItemViewed]: (props) =>
    trackInboxItemViewedSpec(props as InboxItemViewed),

  [TrackingEventName.InboxItemUpdated]: (props) =>
    trackInboxItemUpdatedSpec(props as InboxItemUpdated),

  [TrackingEventName.InboxFilterApplied]: (props) =>
    trackInboxFilterAppliedSpec(props as InboxFilterApplied),
};
